(function($) {
  function handleMenu(menuClass, e) {
    $(`${menuClass} .menu-header-container li`).removeClass("active-li");
    if (e.currentTarget.nodeName.toUpperCase() === "LI") {
      $(e.currentTarget).addClass("active-li");
    }
    if (menuClass === ".menu-tendina") {
      $(".menu-tendina").toggleClass("menu-tendina--active");
      $(".backplate").toggleClass("backplate--open");
      $(".hamburger").toggleClass("is-active");
    }
  }
  $(".header-menu .menu-header-container li").on("click", (e) =>
    handleMenu(".header-menu", e)
  );
  $(".menu-tendina .menu-header-container li").on("click", (e) =>
    handleMenu(".menu-tendina", e)
  );

  var header = $(".header");
  $(".backplate").click(function() {
    $(".menu-tendina").removeClass("menu-tendina--active");
    $(".o-popup").removeClass("o-popup--open");
    $(".hamburger").removeClass("is-active");
    $(".menu-tendina__sub").removeClass("menu-tendina__sub--active");
    $(".btn-nav").removeClass("btn-nav--active");
    $(this).removeClass("backplate--open");
  });
  $(".header-mobile__trigger").click(function() {
    $(".menu-tendina").toggleClass("menu-tendina--active");
    $(".backplate").toggleClass("backplate--open");
    $(".hamburger").toggleClass("is-active");
  });

  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    // if (scroll >= $(window).height()) {
    //   header.addClass("active-scroll");
    // } else {
    //   header.removeClass("active-scroll");
    // }
    if (scroll >= 50) {
      header.addClass("header-v1--scroll");
    } else {
      header.removeClass("header-v1--scroll");
    }
  });
})(jQuery);
